import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-hero-servicios',
  standalone: true,
    imports: [

    ],
  templateUrl: './hero-servicios.component.html',
  styleUrl: './hero-servicios.component.css'
})
export class HeroServiciosComponent {


}
